export default {
  FULLSCREEN: 'fullscreen',
  EXIT_FULLSCREEN: 'exitFullscreen',
  UPDATE_TICKETS: 'updateTickets',
  ADD_TICKET: 'addTicket',
  DELETE_TICKET: 'deleteTicket',
  SUBMIT_ORDER_FORM: 'submitOrderForm',
  SET_SELECTED_TICKETS: 'setSelectedTickets',
  UNSELECT_TICKETS: 'unselectTickets',
  UNSELECT_TICKET: 'unselectTicket',
  UPDATE_MARKETPLACE_TICKET: 'updateMarketplaceTicket',
  DELETE_MARKETPLACE_TICKET: 'deleteMarketplaceTicket',
  SHOW_ORDER_SUCCESS: 'showOrderSuccess',
  UPDATE_WIDGET_HEIGHT: 'updateWidgetHeight',
  SET_SELECTED_DATE: 'setSelectedDate',
  ON_CHANGE_DATE: 'onChangeDate',
  CHANGE_SCHEME_MODE: 'changeSchemeMode',
  ON_TABLE_SECTOR_SELECTED: 'onTableSectorSelected',
  EXIT_TABLE_SECTOR: 'exitTableSector',
  ON_SHOW_ORDER_FORM: 'onShowOrderForm',
  ON_UNSUPPORTED_CURRENCY: 'onUnsupportedCurrency',
  CHANGE_HELP_STATE: 'changeHelpState',
  ORDER_FORM_CHANGED: 'orderFormChanged',
  ORDER_FORM_INPUT_BLURED: 'orderFormInputBlured',
  HIDE_MOBILE_OVERLAY: 'hideMobileOverlay',
  SHOW_MOBILE_OVERLAY: 'showMobileOverlay',
  ON_ADD_ANNOUNCEMENT: 'onAddAnnouncement',
  ON_DELETE_ANNOUNCEMENT: 'onDeleteAnnouncement',
  ON_ADD_STANDING_TICKETS: 'onAddStandingTickets',
  ON_DELETE_STANDING_TICKETS: 'onDeleteStandingTickets',
  GET_SELECTED_DATE: 'GET_SELECTED_DATE',
};
